import { render, staticRenderFns } from "./Wizzard.vue?vue&type=template&id=56e57f66&"
import script from "./Wizzard.vue?vue&type=script&lang=js&"
export * from "./Wizzard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports